<div>
  <h1 mat-dialog-title>{{_title}}</h1>
  <div mat-dialog-content>
    <div [innerHTML]="'Last Update: ' + _lastUpdate"></div>
    <div [innerHTML]="_text"></div>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
  </div>
</div>
